export default __webpack_public_path__ + "static/stanleyknife-7337be6ec9993e4c7221159c54201ef6.png";